import { CFTokens } from '../../../../tokens';
export const COLOR = {
    HOVER: {
        emphasis: CFTokens.COLOR.LINK_EMPHASIS_HOVER,
        'emphasis-alternate': CFTokens.COLOR.LINK_ALTERNATE_EMPHASIS_HOVER,
        primary: CFTokens.COLOR.LINK_PRIMARY_HOVER,
        'primary-alternate': CFTokens.COLOR.LINK_ALTERNATE_PRIMARY_HOVER,
    },
    TEXT: {
        disabled: CFTokens.COLOR.LINK_DISABLED,
        emphasis: CFTokens.COLOR.LINK_EMPHASIS_DEFAULT,
        'emphasis-alternate': CFTokens.COLOR.LINK_ALTERNATE_EMPHASIS_DEFAULT,
        primary: CFTokens.COLOR.LINK_PRIMARY_DEFAULT,
        'primary-alternate': CFTokens.COLOR.LINK_ALTERNATE_PRIMARY_DEFAULT,
    },
};
